const filterItems = {
  'city': {
    key: 'SELL_CITY',
    name: 'city',
    default: ['-1'],
    isRemoteOptions: true,
    allowCancel: false,
    any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } }
  },
  'district': {
    key: 'SELL_DISTRICT',
    name: 'district',
    default: ['-1'],
    isRemoteOptions: 1,
    allowCancel: true,
    multiple: true,
    any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } },
  },
  'school': {
    name: 'school',
    key: 'SELL_SCHOOL',
    default: ['-1'],
    isRemoteOptions: 1,
    allowCancel: true,
    multiple: true,
    any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } },
  },
  'familyType': {
    name: 'familyType',
    key: 'SELL_FAMILY_TYPE',
    default: ['-1'],
    isRemoteOptions: 1,
    allowCancel: true,
    multiple: true,
    any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } },
  },
  'propertyType': {
    name: 'propertyType',
    key: 'SELL_PROPERTY_TYPE',
    default: ['-1'],
    isRemoteOptions: 1,
    allowCancel: true,
    multiple: true,
    any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } },
  },
  'houseType': {
    name: 'houseType',
    key: 'SELL_HOUSE_TYPE',
    default: ['-1'],
    isRemoteOptions: 1,
    allowCancel: true,
    multiple: true,
    any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } },
  },
  'elevator': {
    name: 'elevator',
    default: ['-1'],
    isRemoteOptions: 0,
    allowCancel: true,
    multiple: false,
    any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } },
    addon: [
      { id: '1', name: { 'en-US': 'With Elevator', 'zh-CN': '有电梯' } },
      { id: '0', name: { 'en-US': 'No Elevator', 'zh-CN': '无电梯' } },
    ]
  }

}


export default filterItems
